import {
  CopyValueFragment,
  error,
  money,
  offerBadge,
  tag,
} from 'services/graphql/fragments/Fragments';
import {
  AnalyticsEventFragment,
  SystemBannerFragment,
} from 'services/graphql/fragments/HomeTilesContentFragment';
import { gql } from 'urql';

const FetchMyActivatedOffers = gql`
  query ActivatedOffersPage(
    $filter: ActivatedOffersPageFilterInput
    $first: Int
    $after: String
  ) {
    activatedOffersPage(filter: $filter, first: $first, after: $after) {
      ... on ActivatedOffersPageSuccess {
        __typename
        id
        pageInfo {
          endCursor
          hasNextPage
        }
        activatedItems {
          __typename
          id
          title
          subtitle
          offerSource
          inlineAlertBanner {
            ...SystemBannerFragment
          }
          offers {
            __typename
            id
            merchantId
            primaryText
            secondaryText
            tertiaryText {
              __typename
              distance
              originalPrice {
                ...money
              }
              disountedPrice {
                ...money
              }
              addressText
            }
            companionExtra
            leadingAccessory {
              __typename
              ... on UserAvatar {
                __typename
                userAvatarAsset {
                  __typename
                  ...CopyValueFragment
                  ... on URLType {
                    __typename
                    url
                  }
                }
              }
              ... on VXLIconType {
                __typename
                vXLIconTypeKey: key
              }
              ... on VXLIllustrationType {
                __typename
                vXLIllustrationType: key
              }
            }
            trailingAccessory {
              __typename
              ... on Tag {
                ...tag
              }
              ...offerBadge
            }
            offerSource
            onClick {
              __typename
              route
              analyticsEvent {
                ...AnalyticsEventFragment
              }
            }
          }
        }
      }
      ... on ActivatedOffersPageError {
        __typename
        ...error
      }
    }
  }
  ${AnalyticsEventFragment}
  ${CopyValueFragment}
  ${error}
  ${money}
  ${offerBadge}
  ${SystemBannerFragment}
  ${tag}
`;

export default FetchMyActivatedOffers;
